// @ts-nocheck
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Column from 'components/grid/table/components/column';
import Empty from 'components/grid/table/components/empty';
import ActionsColumn from 'components/grid/table/components/actions-column';
import RenderIf from 'components/if-statement';
import { Table, Container } from 'components/grid/table/styled';
import { isEmpty, noop } from 'lodash';

class TableComponent extends Component<any> {
  static type = 'dataComponent';

  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
    data: PropTypes.array,
    onRowClick: PropTypes.func,
    rowDisabled: PropTypes.func,
    setSort: PropTypes.func,
    sort: PropTypes.string,
    loading: PropTypes.bool,
    empty: PropTypes.node,
    evenRowColor: PropTypes.string,
    oddRowColor: PropTypes.string,
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    className: PropTypes.string,
  };

  static defaultProps = {
    data: [],
    // selectedRows: [],
    setSort: undefined,
    sort: '',
    onRowClick: noop,
    rowDisabled: noop,
    loading: false,
    empty: null,
    // TODO suggestion for zebra functionality
    evenRowColor: 'rgb(250, 250, 250)',
    oddRowColor: 'transparent',
  };

  // This flag is set to true if any of the table fields has searchable prop set to true
  searchable = false;

  emptyElement = this.props.empty || <Empty />;

  fields = [];

  actionsElement = null;

  initTableElements = () => {
    this.fields = [];
    this.actionsElement = null;

    React.Children.forEach(this.props.children, (element) => {
      const { type: Component } = element;

      this.searchable = element.props.searchable ? true : this.searchable;

      if (Component.type === 'actionsComponent') {
        this.actionsElement = element;
      } else {
        this.fields.push(element);
      }
    });
  };

  isEmpty = () => {
    const { data, loading } = this.props;
    return !data || (isEmpty(data) && !loading);
  };

  render() {
    const { data } = this.props;

    this.initTableElements();

    return (
      <Container>
        <Table
          data-type="table"
          data-table-empty={String(this.isEmpty())}
          style={this.props.style}
          className={this.props.className}>
          {this.fields.map((Field, index) => (
            <Column
              {...this.props}
              key={Field.props.name + index}
              Field={Field}
              title={Field?.props?.label}
              // We set this because we want column that is before to have grater zIndex
              zIndex={this.fields.length - index}
              tableSearchable={this.searchable}
              columnNumber={++index}
            />
          ))}

          <RenderIf condition={Boolean(this.actionsElement)}>
            <ActionsColumn
              data={data}
              searchable={this.searchable}
              actionsElement={this.actionsElement}
              zIndex={this.fields.length}
            />
          </RenderIf>

          <RenderIf condition={this.isEmpty()}>{this.emptyElement}</RenderIf>
        </Table>
      </Container>
    );
  }
}

export default TableComponent;
